import { IQuery, IQueryMediator } from 'core-ts-types';
import { ITimeOccurrenceDatatype } from '../datastore/time/data_types';
import { TimeOccurrenceDataSource } from '../datastore/time/time_datasource';

export class BlendedTimesQueryModel implements IQuery {
  public model: ITimeOccurrenceDatatype[];

  constructor(private ngTimeOccurrenceDataSource: TimeOccurrenceDataSource, QueryMediator: IQueryMediator) {
    QueryMediator.registerQuery(this, ngTimeOccurrenceDataSource);
    this.model = [];
  }

  run(): this {
    this.model = _.filter(this.ngTimeOccurrenceDataSource.store, (timeBlock: ITimeOccurrenceDatatype) => {
      return _.includes(timeBlock.icons || '', 'adjust');
    });

    return this;
  }

  getTimes(): ITimeOccurrenceDatatype[] {
    return this.model;
  }

  get result(): ITimeOccurrenceDatatype[] {
    return this.model;
  }
}

angular
  .module('ui-ng-calendar')
  .factory(
    'ngBlendedTimesQueryModel',
    function (ngTimeOccurrenceDataSource: TimeOccurrenceDataSource, QueryMediator: IQueryMediator) {
      return new BlendedTimesQueryModel(ngTimeOccurrenceDataSource, QueryMediator);
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-calendar/src/query_models/blended_times_query_model.ts